export const UPDATE_HIGHLIGHTED_ITEMS = 'UPDATE_HIGHLIGHTED_ITEMS'
export const UPDATE_SEARCH_QUERY = 'UPDATE_SEARCH_QUERY'
export const UPDATE_FOCUSED_ITEM_ID = 'UPDATE_FOCUSED_ITEM_ID'
export const UPDATE_SELECTED_CATEGORY = 'UPDATE_SELECTED_CATEGORY'
export const TOGGLE_SHOW_CLOSED_TABS = 'TOGGLE_SHOW_CLOSED_TABS'
export const SET_SHOW_ONLY_ACTIVE_ATTENDANT = 'SET_SHOW_ONLY_ACTIVE_ATTENDANT'
export const RESET_ATTENDANT_VIEW = 'RESET_ATTENDANT_VIEW'
export const CLEAR_SEARCH = 'CLEAR_SEARCH'

export const updateHighlightedItems = (searchParams) => ({
    type: UPDATE_HIGHLIGHTED_ITEMS,
    payload: { searchParams },
  })
  
export const updateSearchQuery = (searchQuery) => ({
    type: UPDATE_SEARCH_QUERY,
    payload: { searchQuery },
})

export const updateFocusedItemId = (focusedItemId) => ({
    type: UPDATE_FOCUSED_ITEM_ID,
    payload: { focusedItemId },
})

export const updateSelectedCategory = (selectedCategory) => ({
    type: UPDATE_SELECTED_CATEGORY,
    payload: { selectedCategory },
})

export const toggleShowClosedTabs = () => ({
    type: TOGGLE_SHOW_CLOSED_TABS,
})

export const setShowOnlyActiveAttendantOrders = (payload) => ({
    type: SET_SHOW_ONLY_ACTIVE_ATTENDANT,
    payload,
})

export const resetAttendantView = () => ({
    type: RESET_ATTENDANT_VIEW,
})

export const clearSearch = () => ({
    type: CLEAR_SEARCH,
})
